// frontend/src/components/CartoesAnalytics/KpiCard.jsx
//
// KPI dos gráficos de cartão. Existe para que os quatro cards de uma linha tenham
// sempre a mesma altura: a legenda vai no `suffix` do Statistic (mesmo padrão do
// card "Categoria top" em Relatórios), e não como uma segunda linha — foi isso que
// desalinhava "Livre em" e "Dia mais usado" em relação aos vizinhos.

import React from 'react';
import { Card, Col, Statistic, Typography } from 'antd';

const { Text } = Typography;

const fmtBRLCompleto = (valor) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(valor) || 0);

const KpiCard = ({
    titulo,
    valor,
    legenda = null,
    moeda = false,
    cor = null,
    loading = false,
    isMobile = false,
}) => (
    <Col xs={12} md={6}>
        <Card className="desempenho-kpi-card cartoes-analytics-kpi" bordered={false} loading={loading}>
            <Statistic
                title={titulo}
                value={moeda ? Number(valor) || 0 : valor}
                formatter={moeda ? fmtBRLCompleto : undefined}
                valueStyle={{
                    color: cor || undefined,
                    fontVariantNumeric: 'tabular-nums',
                    fontSize: isMobile ? 16 : undefined,
                }}
                suffix={
                    legenda ? (
                        <Text type="secondary" className="cartoes-analytics-kpi-legenda">
                            {legenda}
                        </Text>
                    ) : null
                }
            />
        </Card>
    </Col>
);

export default KpiCard;
